function share(url, popup = false) {
  if (popup) {
    const width = 626;
    const height = 436;
    const x = (window.innerWidth - width) / 2;
    const y = (window.innerHeight - height) / 2;  
    popup = window.open(
      url,
      'sharer',
      `status=no,height=${height},width=${width},resizable=yes,left=${x},top=${y},screenX=${x},screenY=${y},toolbar=no,menubar=no,scrollbars=no,location=no,directories=no`
    )  
    popup.focus();
  } else {
    window.open(url, '_blank');
  }
}

export default {
  methods: {
    shareOnWhatsapp(description, url) {
      share(`https://api.whatsapp.com/send?text=${encodeURIComponent(description)}%0D%0A${encodeURIComponent(url)}`);
    },
    shareOnFacebook(title, description, url) {
      share(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&description=${encodeURIComponent(description)}`, true);
    },
    shareOnMessenger(url) {
      share(`fb-messenger://share?link=${encodeURIComponent(url)}&app_id=${encodeURIComponent(process.env.FB_APP_ID)}`);
    },
    shareOnLinkedin(title, description, url) {
      share(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(description)}`, true);
    },
    shareOnTwitter(title, url, hashtags=[]) {
      const str_hashtags = hashtags.join().replace('/,/g', '+');
      share(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}&hashtags=${str_hashtags}`, true);
    },
    shareOnOthers(title, description, url) {
      if (!!navigator.share) {
        navigator.share({
          title: title,
          text: description,
          url: url,
        });
      } else {
        share(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}%0D%0A%0D%0A${encodeURIComponent(description)}`);
      }
    }
  }
}
